<script>
  import Dropdown from '@components/general/dropdown.svelte'
  import Button from '@components/buttons/button.svelte'
  import { ChevronsUpDown, User, Settings, LogOut } from 'lucide-svelte'
  import { page, router } from '@inertiajs/svelte'

  let user = $derived($page.props.user)
  let initial = $derived(user?.name?.[0] || '')

  function logout() {
    router.delete('/session')
  }
</script>

<Dropdown class="pt-2 border-t border-gray-200" align="start" side="top" offset={8}>

  {#snippet trigger({ props })}
    <Button variant="naked" class="w-full p-0.5 border border-solid border-transparent focus:outline-none focus:ring-0 hover:bg-white hover:border-gray-200/80" {...props}>
      <div class="bg-yellow-400/80 text-yellow-950 hover:bg-yellow-400/90 size-10 text-[14px] font-semibold rounded-lg flex items-center justify-center shadow-none">{initial}</div>
      <div class="flex flex-col items-start justify-center gap-1 leading-none">
        <span class="text-gray-800 font-medium text-[14px] leading-none">{user.name}</span>
        <span class="text-gray-500/70 text-smaller leading-none">{user.email_address}</span>
      </div>
      <div class="ml-auto">
        <ChevronsUpDown size={16} />
      </div>
    </Button>
  {/snippet}

  {#snippet contents(item)}
    
    <!-- The dropdown content header -->
    <div class="flex items-center gap-3 px-4 py-3 border-b border-gray-100">
      <div class="bg-yellow-400/80 text-yellow-950 size-8 text-xs font-semibold rounded-lg flex items-center justify-center shrink-0">{initial}</div>
      <div class="min-w-0">
        <p class="text-sm font-medium text-gray-800 truncate">{user.name}</p>
        <p class="text-xs text-gray-400 truncate">{user.email_address}</p>
      </div>
    </div>
    
    {@render item({ text: "Your profile", icon: User, path: `/settings/profile` })}
    {@render item({ text: "Sign out", icon: LogOut, onSelect: logout })}
  {/snippet}
  
</Dropdown>